module.exports = __webpack_public_path__ + "assets/icons-vendor.6871ae05bc64251b7113276427f45f76.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/icons-vendor.png
 ** module id = 216
 ** module chunks = 0
 **/